<template>
    <div class="container-toogle-transfer-reserves">
        <ui-card-toggle
            design="brightness"
            set-status
            :open="true"
        >
            <template #title>
                <div class="title-transfer-reserves">
                    <em class="fal fa-gear" />

                    <span>Transferência de Reservas</span>
                </div>
            </template>

            <template #content>
                <div class="area-card">
                    <transition v-if="loader.body" name="small-fade">
                        <div class="loading-card">
                            <ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                        </div>
                    </transition>

                    <div v-show="!loader.body" v-for="(field, index) in form.field" :key="index" class="container-fields">
                        <span class="title-fields">
                            {{ field.label }}
                        </span>

                        <div v-for="fields in field.actions" class="container-switch">
                            <span>{{ fields.label }}</span>
                            <ui-switch
                                design="xs"
                                data-ui="switch-transfer-reserves"
                                v-model="fields.active"
                                :checked="fields.active"
                                :disabled="userLogged.user_group != 'admin'"
                            />
                        </div>
                    </div>
                </div>

                <div class="footer-card">
                    <ui-button
                        design="md success"
                        data-ui="button-save-transfer-reserves"
                        :disabled="!canSubmit"
                        @click="submit"
                    >
                        <span v-if="loader.overlay" class="loading-submit-teams">
                            <ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
                        </span>
                        Salvar
                    </ui-button>
                </div>
            </template>
        </ui-card-toggle>
    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiCardToggle } from '@/components/ui/cards'
import { uiSwitch } from '@/components/ui/form'
import { uiLoadSuccess } from '@/components/ui/overlays'
import { alertMixin, formMixin } from '@/mixins'
import { reserves } from '@/services/axios'
import { storage } from '@/services/storage'

    const defaultForm = () => ({
        field: [
            {
                label: 'Ativar Transferência de Reservas',
                actions: [
                    {
                        type: 'transfer',
                        active: false,
                        label: 'Permitir ativação transferência de reservas',
                        name: 'global_reserves_transfer'
                    },
                ]
            }
        ]
    })

    const defaultLoader = () => ({
        body: false,
        overlay: false
    })

    export default {
        name: 'configuration-transfer-reserves',

        components: {
            uiButton,
            uiLoadSuccess,
            uiLoadIndicator,
            uiSwitch,
            uiCardToggle
        },

        mixins: [formMixin, alertMixin],

        data() {
            return {
                form: { ...defaultForm() },
                loader: { ...defaultLoader() },
                oldForm: {},
                userLogged: JSON.parse(storage.get('user_logged')),
            }
        },

        computed: {
            canSubmit() {
                return this.$mx_isFormChanged && !this.loader.body
            }
        },

        async created() {
            await this.load()

            this.$mx_copyOldForm()
        },

        methods: {
            async load() {
                this.loader.body = true
                try {
                    const response = await reserves.getConfigGlobal()
                    this.formatForm(response.data.data)
                } catch (error) {
                    if (error.data?.msg) {
                        this.$mx_alertError(error.data.msg)
                    }
                } finally {
                    this.loader.body = false
                }
            },

            async submit() {
                let configurations = []

                this.form.field.forEach(item => {
                    item.actions.forEach(value => {
                        configurations.push({
                            active: value.active,
                            name: value.name
                        })
                    })
                })

                this.loader.overlay = true
                try {
                    const response = await reserves.postConfigGlobal(configurations)
                    this.$mx_alertSuccess(response.data.msg)
                    this.$root.$emit("load-transfer-menu", configurations)
                    this.$mx_copyOldForm()
                } catch (error) {
                    if (error.data?.msg) {
                        this.$mx_alertError(error.data.msg)
                    } else {
                        this.$mx_alertError(error)
                    }
                } finally {
                    this.loader.overlay = false
                }
            },

            formatForm(data) {
                this.form.field.forEach(field => {
                    field.actions.forEach(action => {
                        if (data.hasOwnProperty(action.name)) {
                            action.active = data[action.name].active
                        }
                    })
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
